<template>

    <div class="level" v-if="title !== 'Minha Aula'">
        <div class="level-left is-hidden-mobile">
            <div class="level-item">
                <transition mode="out-in"
                    enter-active-class="fadeIn"
                    leave-active-class="fadeOut">
                    <p class="title is-5 animated"
                        id="page-title"
                        v-if="loaded">
                        {{ __(title) }}
                    </p>
                </transition>
            </div>
        </div>
        <div class="level-right">
            <div class="level-item">
                <transition
                    mode="out-in"
                    enter-active-class="fadeInRight"
                    leave-active-class="fadeOutRight">
                </transition>
            </div>
        </div>
    </div>

</template>

<script>

import Breadcrumbs from './Breadcrumbs.vue';

export default {
    name: 'PageHeader',

    components: { Breadcrumbs },

    props: {
        title: {
            type: String,
            default: null,
        },
    },

    data() {
        return {
            loaded: true,
        };
    },

    watch: {
        title: {
            handler() {
                this.loaded = false;
                setTimeout(() => {
                    this.loaded = true;
                }, 350);
            },
        },
    },
};

</script>

<style lang="scss" scoped>
    @media screen and (max-width: 768px) {
        .level-left+.level-right {
            margin-top: unset;
        }
    }
</style>



// WEBPACK FOOTER //
// resources/js/core/structure/PageHeader.vue